<template>
    <div class="form-element__container form-element__container--select" :id="fullFormIdentifier + '-container'">
        <select
            ref="dealer-select"
            :id="fullFormIdentifier"
            v-model="locationId"
            class="form-element__input"
            :class="{ 'form-element__input--active': isFilled }"
            name="location-id"
            data-validate="select"
            data-validate-message="Please select a dealer"
            data-location-element="true"
            data-location-list="true"
            data-populate-dealers="true"
            :data-used="filterUsed"
            :data-new="filterNew"
            :data-initial-location-id="locationId"
            :data-use-brand="filterDealersByBrand"
        >
            <option value="" disabled selected>Please select a dealer</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        formIdentifier: {
            type: String,
            default: 'form',
        },
        filterUsed: {
            type: Boolean,
            default: false,
        },
        filterNew: {
            type: Boolean,
            default: false,
        },
        filterDealersByBrand: {
            type: String,
            default: null,
        },
    },
    data() {
        return {};
    },
    mounted() {
        this.$refs['dealer-select'].addEventListener('automatic_change', event => {
            this.$store.dispatch("CustomerData/storeCustomerData", {locationId: event.target.value});
        })
    },
    computed: {
        isFilled() {
            if (this.locationId == null) {
                return false;
            }

            if (this.locationId == '') {
                return false;
            }

            if (this.locationId == 0) {
                return false;
            }

            return true;
        },
        locationId: {
            get: function () {
                return this.$store.state.CustomerData.locationId;
            },
            set: function (newValue){
                this.$store.dispatch("CustomerData/storeCustomerData", {locationId: newValue});
                this.$emit('location-updated', newValue);
            }
        },
        fullFormIdentifier() {
            return this.formIdentifier + '-' + this._uid;
        },
    },
}
</script>